(function () {
  if (!window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart || !Shopify.theme.cart) {
    return;
  }

  var ajaxCart = Shopify.theme.ajaxCart;

  function restoreButton(context, selectors, config) {
    var button = context.querySelector(selectors.addToCart);
    button.value = button.hasAttribute('data-preorder') ? config.pre_order : config.add_to_cart;
    button.classList.remove('disabled');
    button.removeAttribute('disabled');
  }

  function showAddedState(context, selectors, config) {
    var button = context.querySelector(selectors.addToCart);
    button.value = config.added_to_cart;
    button.classList.remove('disabled');
    button.removeAttribute('disabled');
    window.setTimeout(function () {
      restoreButton(context, selectors, config);
    }, 3000);
  }

  function showCartDestination(context, selectors, config, isQuickview) {
    if (isQuickview && config.cart_added_event !== 'product_page') {
      if (document.querySelector('[data-wau-modal="quickview"]')) {
        Shopify.theme.quickview.hideModal();
      } else {
        Shopify.theme.quickview.hideSlideout();
      }
    } else if (isQuickview && config.cart_added_event === 'product_page') {
      theme.Helpers.fadeIn(context.querySelector(selectors.cartAddedMsg));
      window.setTimeout(function () {
        theme.Helpers.fadeOut(context.querySelector(selectors.cartAddedMsg));
      }, 3000);
    }

    if (config.cart_action === 'drawer' && config.cart_added_event === 'go_to_active_cart') {
      ajaxCart.showDrawer(config);
      return false;
    }

    if (config.cart_action === 'modal_cart' && config.cart_added_event === 'go_to_active_cart') {
      ajaxCart.showModal(config);
      return false;
    }

    if (config.cart_action === 'page_only' && config.cart_added_event === 'go_to_active_cart') {
      window.location.href = config.cart_url;
      return true;
    }

    if (config.cart_added_event === 'product_page') {
      theme.Helpers.fadeIn(context.querySelector(selectors.cartAddedMsg));
      window.setTimeout(function () {
        theme.Helpers.fadeOut(context.querySelector(selectors.cartAddedMsg));
      }, 3000);
      return false;
    }

    window.location.href = config.cart_url;
    return true;
  }

  function renderCart(config, cart, response) {
    var html = ajaxCart.getAjaxCart(response);
    var selectors = {
      cartContent: '.js-ajax-cart-content',
      cartEmpty: '.js-cart-empty',
      cartForm: '.js-cart-form',
      cartAccordion: '.js-cart-accordion',
      cartCount: '.js-cart-count'
    };
    var footerWrapper = document.querySelector('#dynamic');

    if (footerWrapper) {
      footerWrapper.style.display = cart.item_count < 1 ? 'none' : 'block';
    }

    if (cart.item_count === 0) {
      document.querySelectorAll(selectors.cartForm).forEach(function (element) {
        element.classList.add('hide');
      });
      document.querySelectorAll(selectors.cartEmpty).forEach(function (element) {
        element.classList.remove('hide');
      });
      document.querySelectorAll(selectors.cartCount).forEach(function (element) {
        element.innerHTML = '0';
      });
    } else {
      document.querySelectorAll(selectors.cartEmpty).forEach(function (element) {
        element.classList.add('hide');
      });
      document.querySelectorAll(selectors.cartCount).forEach(function (element) {
        element.innerHTML = cart.item_count;
      });
      document.querySelectorAll(selectors.cartContent).forEach(function (element) {
        element.innerHTML = html.content;
      });
      document.querySelectorAll(selectors.cartAccordion).forEach(function (element) {
        theme.Helpers.Accordion(element, '.tlink.has_sub_menu a', '.accordion-content.sub');
        theme.Helpers.Accordion(element, '.tlink2.has_sub_menu a', '.accordion-content2.sub');
      });
      ajaxCart.cartEvents(config);
    }

    window.setTimeout(function () {
      document.body.classList.add('cart-loaded');
      var checkoutButtons = document.querySelectorAll('#dynamic-checkout-cart');
      if (checkoutButtons.length === 2) {
        checkoutButtons[1].remove();
      }
    }, 500);
  }

  function refreshCartInParallel(config) {
    var cartPromise = Shopify.theme.cart.getCart();
    var drawerPromise = fetch(config.cart_url + '/?view=ajax').then(function (response) {
      if (!response.ok) {
        throw response;
      }
      return response.text();
    });

    return Promise.all([cartPromise, drawerPromise]).then(function (results) {
      renderCart(config, results[0], results[1]);
    }).catch(function () {
      return Shopify.theme.cart.getCart().then(function (cart) {
        ajaxCart.updateView(config, cart);
      }).catch(function () {
        window.location.href = config.cart_url;
      });
    });
  }

  ajaxCart.addToCart = function (addToCartForm, formContext, config, isQuickview) {
    var selectors = {
      addToCart: '.js-ajax-submit',
      cartAddedMsg: '.js-added-msg'
    };
    var context = isQuickview ? document.querySelector('.js-quickview-content') : formContext;
    var recipientFields = Array.prototype.slice.call(addToCartForm.elements).filter(function (element) {
      return element.name === 'properties[__shopify_send_gift_card_to_recipient]' && element.checked;
    });

    if (recipientFields.length !== 0) {
      var recipientConfig = Shopify.theme.cart.getDefaultRequestConfig();
      var recipientFormData = new FormData(addToCartForm);
      delete recipientConfig.headers['Content-Type'];
      recipientConfig.method = 'POST';
      recipientConfig.body = recipientFormData;
      fetch('/cart/add.js', recipientConfig).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.status === 422) {
          Events.trigger('recipientform:errors', data.message, data.description, config, addToCartForm);
        }
      }).catch(function (error) {
        console.error(error);
      });
    }

    if (theme.ProductProperties.checkLineItemProperties(addToCartForm) === false) {
      return;
    }

    var button = context.querySelector(selectors.addToCart);
    button.value = config.adding_to_cart;
    button.classList.add('disabled');
    button.setAttribute('disabled', 'disabled');
    document.querySelectorAll('.required-error').forEach(function (element) {
      element.classList.remove('required-error');
    });

    Shopify.theme.cart.addItemFromForm(addToCartForm).then(function () {
      showAddedState(context, selectors, config);
      var navigated = showCartDestination(context, selectors, config, isQuickview);
      if (!navigated) {
        refreshCartInParallel(config);
      }
    }).catch(function (error) {
      if (error.status === 422) {
        theme.Helpers.fadeIn(context.querySelector('.js-error-msg'));
        restoreButton(context, selectors, config);
        window.setTimeout(function () {
          theme.Helpers.fadeOut(context.querySelector('.js-error-msg'));
        }, 3000);
      } else {
        console.log(error);
      }
    });
  };
})();
